"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomesticReviewPhotoListPageRequestSchema = exports.DomesticReviewPhotoListPageQuery = exports.DomesticReviewPhotoListPageResources = void 0;
var zod_1 = require("zod");
exports.DomesticReviewPhotoListPageResources = zod_1.z.object({
    propertyId: zod_1.z.number(),
});
exports.DomesticReviewPhotoListPageQuery = zod_1.z.object({
    /**
     * 원하는 pagination 값
     * page가 undefined일경우 1페이지로 간주
     * ex) 1페이지를 원할경우 page: 1 or page: undefined
     * ex) 2페이지를 원할경우 page: 2
     * ex) 3페이지를 원할경우 page: 3
     * */
    page: zod_1.z.number().optional(),
    /** 객실 전체를 선택하고 싶은 경우 [] 보내면 됨 */
    roomTypeIds: zod_1.z.array(zod_1.z.number()),
});
exports.DomesticReviewPhotoListPageRequestSchema = zod_1.z.object({
    resources: exports.DomesticReviewPhotoListPageResources,
    query: exports.DomesticReviewPhotoListPageQuery,
});
